var initGmap = function(thisId, markerJson, thisNearest, thisItinerary) {

	//create map object
	function createMap() {

		var mapOptions = {
			zoom: 9,
			center: new google.maps.LatLng(markerJson['markerData'][0].lat,markerJson['markerData'][0].long),
			maxZoom: 9,// this is low to catch any maps with only 1 marker
			// UI Controls
			panControl: false,
			scaleControl: false,
			streetViewControl: true,
			overviewMapControl: false,
			scrollwheel: false,

			mapTypeControl: true,
			mapTypeControlOptions: {
				style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
				mapTypeIds: [
					google.maps.MapTypeId.ROADMAP,
					google.maps.MapTypeId.TERRAIN
				]
			},
			mapTypeId: google.maps.MapTypeId.TERRAIN,

			zoomControl: true,
			zoomControlOptions: {
				style: google.maps.ZoomControlStyle.SMALL
			}
		};

		// Map object
		var map = new google.maps.Map(document.getElementById(thisId), mapOptions);

		// set map object to element's data attribute so we can get the map object outside of scope 
		document.getElementById(thisId).setAttribute('data-map', map);

		// Event to allow scrollwheel after click
		google.maps.event.addDomListener(map, 'click', function() {
			this.setOptions({scrollwheel:true});
		});

		// Set zoom back after initial set up (so single markers aren't zoomed in too much)
		google.maps.event.addListenerOnce(map, 'bounds_changed', function() {
			if (markerVisible==1){
				// [SCS-1585] map was setting bounds after max zoom was set, delay to fix this
				setTimeout(function(){
					map.setOptions({maxZoom: 18});
				}, 500);
			}
			else {
				map.setOptions({maxZoom: 18});
			}
		});

		if(markerJson){
			// Add all markers and info windows
			setMarkers(map);
		}
	}

	// Icons Image Path Setup
	var iconPos = new Array();
	var imgPath = '/assets/front/dist/img/retina/swoop-gmap-marker-sprite.png';
	var spriteItemWidth = 32;
	var spriteItemHeight = 48;
	var startEndSame = false;
	var markerLength = markerJson['markerData'].length;
	var markerVisible = 0;

	if (markerLength > 1) {
		if (markerJson['markerData'][0].lat == markerJson['markerData'][markerLength-1].lat 
				&& markerJson['markerData'][0].long == markerJson['markerData'][markerLength-1].long) {
			// Start and end locations are the same
			startEndSame = true;
		}
	}

	// Set colour / sprite pos of markers
	for (var i = 0; i < markerLength; i++) {
		var x = spriteItemWidth; //marker with dot
		var y = 0;
		
		if (thisNearest || thisItinerary){
			if (i == 0) {
				y = spriteItemHeight; // make yellow
			}
		}
		
		if (thisItinerary) {
			if (i == markerLength-1) {
				y = spriteItemHeight; // make yellow
			}

			if (i == 0 || i == markerLength-1) {//first or last
				x = 0;
			}
			else {
				x = (spriteItemWidth*2)+(spriteItemWidth*(i-1)); // Set numbber
			}

		}
		
		iconPos.push([x,y]);
	}

	// Info window init
	var infowindow = new google.maps.InfoWindow({
		content: 'loading...',
		maxWidth: 350
	});

	// Array to store all markers
	var markers = new Array();


	// Place all markers
	function setMarkers(map) {

		// Add markers to the map
		for (var i = 0; i < markerLength; i++) {

			if (startEndSame && i==markerLength-1){
				break;
			}

			var myLoc = markerJson['markerData'][i];
			var myLatLng = new google.maps.LatLng(myLoc.lat, myLoc.long);

			var image = {
				url: imgPath,
				// This marker is 22 pixels wide by 40 pixels tall.
				size: new google.maps.Size(spriteItemWidth, spriteItemHeight),
				// The marker image is twice size for retine
				scaledSize: new google.maps.Size(704, 96), // the new size you want to use
				// Sprite position of image
				origin: new google.maps.Point(iconPos[i][0],iconPos[i][1]),
				// The anchor for this image is the base
				anchor: new google.maps.Point(16, 48)
			};
			
			var myIndex = i;
			
			if (i==0 || i==markerLength-1){
				myIndex = markerLength +i;
			}
			
			var marker = new google.maps.Marker({
				position: myLatLng,
				map: map,
				icon: image,
				//title: "<h4>" + myLoc.title + "</h4>",
				html: "<h4>" + myLoc.title + "</h4>"+myLoc.html,
				zIndex: myIndex,
				myTitle: "<h4>" + myLoc.title + "</h4>"
			});
			
			markers.push(marker);
			
			/**
			google.maps.event.addListener(marker, 'click', function () {
				if(this.title!=undefined || this.html!=undefined){
					var infoContent = "";
					if(this.title!=undefined){
						infoContent += this.title;
					}
					if(this.html!=undefined){
						infoContent += this.html;
					}
					infowindow.setContent(infoContent);
					infowindow.open(map, this);
				}
			});
			*/

			// Create rollover tooltips
			
			//create an options object
			var chTooltipHtml = "<h4>"+marker.myTitle+"</h4>";
			var tooltipOptions = {marker:marker, content:chTooltipHtml, cssClass:'map-tooltip'};
		
			// create the tooltip
			var tooltip = new Tooltip(tooltipOptions);

		}

		// Center the map
		autoCenter(map, thisItinerary);
	}

	function autoCenter(map, itinerary) {

		//  Create a new viewpoint bound
		var bounds = new google.maps.LatLngBounds();
		//  Go through each...
		for (var i = 0; i < markers.length; i++) {
			bounds.extend(markers[i].position);
		}

		markerVisible = 1;
		//  Fit these bounds to the map
		map.fitBounds(bounds);
	}

	function markerClick(id){
				// Gmap object is stored as data attr
				var thisMap = $("#"+thisId).data('map');
				
				// Center including all markers
				autoCenter(thisMap, false);
				
				// Trigger info window
				google.maps.event.trigger(markers[id], 'click');
		}

		/* ----------- Tooltip hover ------------ */

		// create a constructor
	function Tooltip(options) {
		// Now initialize all properties.
		this.marker_ = options.marker;
		this.content_ = options.content;
		this.map_ = options.marker.get('map');
		this.cssClass_ = options.cssClass||null;
		// We define a property to hold the content's
		// div. We'll actually create this div
		// upon receipt of the add() method so we'll
		// leave it null for now.
		this.div_ = null;
		//Explicitly call setMap on this overlay
		this.setMap(this.map_);
		var me = this;
		// Show tooltip on mouseover event.
		google.maps.event.addListener(me.marker_, 'mouseover', function() {
			me.show();
		});
		// Hide tooltip on mouseout event.
		google.maps.event.addListener(me.marker_, 'mouseout', function() {
			me.hide();
		});
	}

	// Now we extend google.maps.OverlayView()
	Tooltip.prototype = new google.maps.OverlayView();

	// onAdd is one of the functions that we must implement,
	// it will be called when the map is ready for the overlay to be attached.
	Tooltip.prototype.onAdd = function() {
		// Create the DIV and set some basic attributes.
		var div = document.createElement('DIV');
		div.style.position = "absolute";
		// Hide tooltip
		div.style.visibility = "hidden";
		if(this.cssClass_)
		div.className += " "+this.cssClass_;
		//Attach content to the DIV.
		div.innerHTML = this.content_;
		// Set the overlay's div_ property to this DIV
		this.div_ = div;
		// We add an overlay to a map via one of the map's panes.
		// We'll add this overlay to the floatPane pane.
		var panes = this.getPanes();
		panes.floatPane.appendChild(this.div_);
	}

	// We here implement draw
	Tooltip.prototype.draw = function() {
	// Position the overlay. We use the position of the marker
	// to peg it to the correct position, just northeast of the marker.
	// We need to retrieve the projection from this overlay to do this.
	var overlayProjection = this.getProjection();
	// Retrieve the coordinates of the marker
	// in latlngs and convert them to pixels coordinates.
	// We'll use these coordinates to place the DIV.
	var ne = overlayProjection.fromLatLngToDivPixel(this.marker_.getPosition());
	// Position the DIV.
	var div = this.div_;
		div.style.left = ne.x + 'px';
		div.style.top = ne.y + 'px';
	}
	// We here implement onRemove
	Tooltip.prototype.onRemove = function() {
		this.div_.parentNode.removeChild(this.div_);
	}
	// Note that the visibility property must be a string enclosed in quotes
	Tooltip.prototype.hide = function() {
		if (this.div_) {
			this.div_.style.visibility = "hidden";
		}
	}
	Tooltip.prototype.show = function() {
		if (this.div_) {
			this.div_.style.visibility = "visible";
		}
	}

	var markerLinks = document.querySelectorAll('.map-key .map-marker-link');
	
	if (markerLinks.length) {
		markerLinks[0].addEventListener('click', function(e) {
			e.preventDefault();
			markerClick(e.target.getAttribute('data-map-id'));
		});
	}

	createMap();
}


var initMaps = function(){
	var maps = document.querySelectorAll('.map-canvas');

	for (var i =0; i < maps.length; i++) {
		// Get ID of element and use this as selector
				var thisID = maps[i].getAttribute('id');
				// is this a nearest landmark?
				var thisNearest = maps[i].classList.contains('map-nearest')
					? true
					: undefined;

				// is this an itinerary?
				var thisItinerary = maps[i].classList.contains('map-itinerary') 
					? true
					: undefined;

				// Get any marker information
				if (maps[i].getAttribute('data-gmap-markers') != undefined) {
					initGmap(
						thisID,
						JSON.parse(maps[i].getAttribute('data-gmap-markers')), 
						thisNearest,
						thisItinerary
					);
				}
	};

}

var initFrontGmap = function() {
	var url = 'https://maps.googleapis.com/maps/api/js?v=3.exp'
		+'&key=AIzaSyAcmlA5QXAFvB8V571XomcWYllkQ1ltyk0'
		+'&callback=initMaps';

		const maps = document.querySelectorAll('.map-canvas');
		const config = {
			rootMargin: '100px',
			threshold: 0.01
		};

		let observer = new IntersectionObserver(
			function onIntersection(entries) {
				entries.forEach(entry => {
					var isIntersecting = typeof entry.isIntersecting === 'boolean' ? entry.isIntersecting : entry.intersectionRatio > 0;

					if (isIntersecting) {
						observer.unobserve(entry.target);
						console.log('Lazy loading GMaps');
						loadjs(url)
					}
				});
			},
			config
		);

		maps.forEach(map => {
			observer.observe(map);
		});
};

/** ON DOM READY **/
window.addEventListener("load", function(event) {
	var maps = document.querySelectorAll('.map-canvas');

	if (maps.length) {
		initFrontGmap();
	}
});